// API client for communicating with the AlphaBot backend
// Supports Cloudflare Pages deployment with backend connection

// Direct tunnel URL - bypass Worker
const DEFAULT_BACKEND_URL = "https://combo-portal-intended-civilian.trycloudflare.com";

// Build-time env var fallback
const BUILD_API_URL = import.meta.env.VITE_API_URL || import.meta.env.VITE_PROXY_URL;

// Runtime override: users can set localStorage.setItem("alphabot_api_url", "https://...")
function getApiBase(): string {
  if (typeof window !== "undefined") {
    try {
      const runtimeUrl = localStorage.getItem("alphabot_api_url");
      if (runtimeUrl) return runtimeUrl;
    } catch {
      // ignore localStorage errors
    }
  }
  // Priority: 1) Build env var, 2) Default tunnel URL, 3) localhost
  return BUILD_API_URL || DEFAULT_BACKEND_URL || "http://localhost:8000";
}

export const API_BASE = getApiBase();

export async function fetchMarkets() {
  const res = await fetch(`${API_BASE}/api/markets/list?limit=5000`);
  if (!res.ok) throw new Error(`Markets fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchOrderbook(tokenId: string) {
  const res = await fetch(`${API_BASE}/api/markets/orderbook?token_id=${tokenId}`);
  if (!res.ok) throw new Error(`Orderbook fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchBinancePrice(symbol: string) {
  const res = await fetch(`${API_BASE}/proxy/binance/api/v3/ticker/price?symbol=${symbol.toUpperCase()}`);
  if (!res.ok) throw new Error(`Binance fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchAgentLogs(count: number = 50) {
  const res = await fetch(`${API_BASE}/api/agents/logs?count=${count}`);
  if (!res.ok) throw new Error(`Agent logs fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchCrewStatus() {
  const res = await fetch(`${API_BASE}/api/bot/status`);
  if (!res.ok) throw new Error(`Status fetch failed: ${res.status}`);
  return res.json();
}

export async function startCrew() {
  const res = await fetch(`${API_BASE}/api/bot/start`, { method: "POST" });
  if (!res.ok) throw new Error(`Start failed: ${res.status}`);
  return res.json();
}

export async function stopCrew() {
  const res = await fetch(`${API_BASE}/api/bot/stop`, { method: "POST" });
  if (!res.ok) throw new Error(`Stop failed: ${res.status}`);
  return res.json();
}

export function getWsUrl(): string {
  const base = API_BASE.replace("http://", "ws://").replace("https://", "wss://");
  return `${base}/ws/agents`;
}
